export default __webpack_public_path__ + "static/media/ketoenergybar-wide@3x.53073cc6.jpg";